import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import API from '../api';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

const Dashboard = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    fetchUserPosts();
  }, []);

  const fetchUserPosts = async () => {
    try {
      setLoading(true);
      const response = await API.get('/posts');
      const userPosts = response.data.posts.filter(post => 
        post.author._id === user.id
      );
      setPosts(userPosts);
    } catch (error) {
      toast.error('Failed to fetch your posts');
      console.error('Error fetching user posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeletePost = async (postId) => {
    if (window.confirm('Are you sure you want to delete this post?')) {
      try {
        await API.delete(`/posts/${postId}`);
        toast.success('Post deleted successfully');
        fetchUserPosts();
      } catch (error) {
        toast.error('Failed to delete post');
        console.error('Error deleting post:', error);
      }
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return <div className="text-center mt-3">Loading your posts...</div>;
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Dashboard</h1>
        <Link to="/create-post" className="btn btn-primary">
          Create New Post
        </Link>
      </div>

      <div className="card mb-4">
        <h3>Welcome, {user.username}!</h3>
        <p>Manage your posts and profile from here.</p>
      </div>

      <h2>Your Posts</h2>
      
      {posts.length === 0 ? (
        <div className="text-center">
          <h3>No posts yet</h3>
          <p>Create your first post to get started!</p>
          <Link to="/create-post" className="btn btn-primary">
            Create Your First Post
          </Link>
        </div>
      ) : (
        <div>
          {posts.map((post) => (
            <div key={post._id} className="card">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h3>
                  <Link 
                    to={`/post/${post._id}`}
                    style={{ color: '#007bff', textDecoration: 'none' }}
                  >
                    {post.title}
                  </Link>
                </h3>
                <small style={{ color: '#666' }}>
                  {formatDate(post.createdAt)}
                </small>
              </div>
              
              <p style={{ color: '#555', marginBottom: '1rem' }}>
                {post.content.length > 200 
                  ? `${post.content.substring(0, 200)}...` 
                  : post.content
                }
              </p>
              
              <div className="d-flex justify-content-between align-items-center">
                <div style={{ color: '#666' }}>
                  <span>❤️ {post.likes.length}</span>
                  <span style={{ marginLeft: '1rem' }}>
                    💬 {post.comments.length}
                  </span>
                  <span style={{ marginLeft: '1rem' }}>
                    Status: {post.isPublished ? 'Published' : 'Draft'}
                  </span>
                </div>
                
                <div>
                  <Link 
                    to={`/edit-post/${post._id}`}
                    className="btn btn-secondary me-2"
                  >
                    Edit
                  </Link>
                  <button 
                    onClick={() => handleDeletePost(post._id)}
                    className="btn btn-danger"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dashboard; 